import { useEffect } from 'react';
import { logError } from '../utils/logger';

/** Logs `error` exactly once where it is non-nullish, via useEffect. */
export function useTrackError(error: unknown, message?: string): void {
  useEffect(() => {
    if (error === null || error === undefined) return;
    logError(error, message);
  }, [error, message]);
}
